// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb--Breadcrumb-components__189rY"};